export function mapLink(coordsString) {
  try {
    let coords = JSON.parse(coordsString);
    return `https://yandex.ru/maps/?ll=${coords[1]}%2C${coords[0]}&pt=~${coords[1]}%2C${coords[0]}&z=17`;
  } catch (e) {
    return "";
  }
}
